import router from '@/router'

// Only run on client-side and only in production mode
if (process.env.NODE_ENV === 'production') {
  (function () {
    const hm = document.createElement('script')
    hm.src = `https://hm.baidu.com/hm.js?${process.env.BAIDU_TONGJI_ID}`
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
  })()

  router.afterEach((to, from) => {
    window._hmt && window._hmt.push(['_trackPageview', to.fullPath])
  })
}



// WEBPACK FOOTER //
// ./src/plugins/baidu-tongji.js